"use strict";
document.addEventListener('DOMContentLoaded', function() {
  // Clone every logo strip's contents for a seamless marquee effect
  const logoStrips = Array.from(document.querySelectorAll('.logo-strip')).forEach(function (logoStrip) {
    const logos = logoStrip.querySelector('.logo-wrapper .logo-inner > div');
    const copies = 2;
    for (let i = 0 ; i < copies ; i++) {
      const clone = logos.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true'); // Don't repeat the content for screen readers
      logos.after(clone);
    }
  });

  const header = document.querySelector('#shopify-section-header > header');
  const firstSection = document.querySelector('#main-content > .shopify-section:first-child');
  
  function adjustForHeaderHeight() {
    const headerHeight = header.clientHeight;
    firstSection.style.setProperty('--MUSE-first-section-header-overlap', String(Math.ceil(headerHeight)) + 'px');
  }
  
  adjustForHeaderHeight();

  let debounce = null;
  window.addEventListener('resize', function() {
    clearTimeout(debounce);
    debounce = setTimeout(adjustForHeaderHeight, 250);
  });
});

jQuery(document).ready(function($) {
  // scrolldown arrow animation
  if ($('.hero-section').length > 0) {
    function scrollDownArrow() {
      $(".hero-section .scroldown .btn-down img").css({"animation":"wheel 2s ease-in-out"});
      setTimeout(function(){
        $(".hero-section .scroldown .btn-down img").css({"animation":"none"});
      }, 2000);
    }
  
    function arrowAnimHandler(e) {
      e.target.pause();
      
      setTimeout(function(){
        e.target.play();
        scrollDownArrow();
      }, 2000);
    }
  
    // video play logic
    $(document).on('ended', '#museBgVideo, #museBgVideoMobile', arrowAnimHandler);
  }
})